import ErrorN from "../../assets/images/errors/errorNetwork.png";
import MainContainer from "../../components/container/MainContainer";
import Navbar from "../../components/navigation/Navbar";
import { Link } from "react-router-dom";

const NetworkError = ({ to, message = "Network Error" }) => {
  return (
    <MainContainer className="bg-bkg pt-3 px-12">
      {/* <Navbar /> */}
      <div className="bg-bkg flex flex-col items-center justify-center h-auto  sm:py-20 ">
        <h3 className="font-semibold text-text-1 mb-4">{message}</h3>
        <img
          src={ErrorN}
          alt="Not Authorized"
          className="w-64 h-64 md:w-80 md:h-80 mb-8 object-cover"
        />
        <p className="text-text-1/60 text-center max-w-md">
          Please contact your administrator if you believe this is an error,
        </p>
        <Link
          to={
            to === "/network-error"
              ? "/dashboard"
              : to === undefined
              ? "/dashboard"
              : to
          }
          reloadDocument
          className="text-text-1 add-rss-btn"
        >
          Try Again
        </Link>
      </div>
    </MainContainer>
  );
};

export default NetworkError;
